<form>
  <mat-form-field appearance="outline" class="wide">
    <mat-label>Holding Company Name</mat-label>
    <input matInput type="text" [formControl]="filterControl" />
  </mat-form-field>
</form>
